import React from "react";
import PropTypes from "prop-types";
import Card from "../card/Card";
import List from "../list/List";
import ListItem from "../list-item/ListItem";

const VehicleDetails = (props) => {
    const { direction, vehicleDetailsData } = props;

    const displayData = () => {
        if (vehicleDetailsData) {
            return (
                <div className="card-container">
                    <Card cardTitle="Vehicle Details" cardIcon="fas fa-car">
                        <div className={`d-flex pl-31 flex-wrap flex-${direction}`}>
                            <List>
                                <div className="card-col__1 mt-9">
                                    <ListItem itemKey="VIN" itemValue={vehicleDetailsData.vin} />
                                </div>
                                <div className="card-col__1 mt-11">
                                    <ListItem itemKey="Vehicle Make" itemValue={vehicleDetailsData.make} />
                                </div>
                                <div className="card-col__1 mt-11">
                                    <ListItem itemKey="Model" itemValue={vehicleDetailsData.model} />
                                </div>
                                <div className="card-col__1 mt-11">
                                    <ListItem itemKey="Year" itemValue={vehicleDetailsData.year} />
                                </div>
                            </List>
                        </div>
                    </Card>
                </div>
            )
        }
    }

    return (
        <React.Fragment>
            {displayData()}
        </React.Fragment>
    )
};

VehicleDetails.propTypes = {
    direction: PropTypes.string,
    vehicleDetailsData: PropTypes.object
}

export default VehicleDetails;